import { calculateDynamicPadding } from 'utils/padding.utils';

/**
 * Font size configuration ranges for login modal search form elements
 * These values align with Portal configuration validation
 */
export const LOGIN_MODAL_FONT_RANGES = {
  TITLE: { min: 14, max: 72, maxPadding: 22, minPadding: 0 },
  TAB: { min: 14, max: 28, maxPadding: 12, minPadding: 20 },
  BUTTON: { min: 12, max: 24, maxPadding: 12, minPadding: 20 },
} as const;

/**
 * Calculate padding for login modal title based on font size
 * @param fontSize - Font size in pixels
 * @returns Calculated padding in pixels
 */
export const calculateTitlePadding = (fontSize: number): number => {
  const { min, max, maxPadding } = LOGIN_MODAL_FONT_RANGES.TITLE;
  return calculateDynamicPadding(fontSize, min, max, maxPadding);
};

/**
 * Calculate padding for login modal tabs based on font size
 * @param fontSize - Font size in pixels
 * @returns Calculated padding in pixels
 */
export const calculateTabPadding = (fontSize: number): number => {
  const { min, max, maxPadding, minPadding } = LOGIN_MODAL_FONT_RANGES.TAB;
  return calculateDynamicPadding(fontSize, min, max, maxPadding, minPadding);
};

/**
 * Calculate padding for login modal button based on font size
 * @param fontSize - Font size in pixels
 * @returns Calculated padding in pixels
 */
export const calculateButtonPadding = (fontSize: number): number => {
  const { min, max, maxPadding, minPadding } = LOGIN_MODAL_FONT_RANGES.BUTTON;
  return calculateDynamicPadding(fontSize, min, max, maxPadding, minPadding);
};
